import {
  Gem,
  Sparkles,
  AlertTriangle,
  Microscope,
  DoorOpen,
  FileStack,
} from "lucide-react";
import PageHero from "../../components/shared/PageHero";
import CtaBand from "../../components/shared/CtaBand";
import "./UnlistedSharesPage.css";

const SECTIONS = [
  {
    icon: Gem,
    title: "Available Opportunities",
    desc: "Curated pre-IPO and unlisted equity opportunities screened for business quality, valuation context, and documentation readiness.",
  },
  {
    icon: Sparkles,
    title: "Benefits",
    desc: "Early access to growth stories before listing, potential diversification beyond listed markets, and structured onboarding with clear paperwork.",
  },
  {
    icon: AlertTriangle,
    title: "Risks",
    desc: "Lower liquidity, valuation uncertainty, longer holding periods, and company-specific risk. Unlisted investing is suitable only for informed investors.",
  },
  {
    icon: Microscope,
    title: "Research-Based Selection",
    desc: "We evaluate financials, promoter track record, sector outlook, and peer comparisons before presenting any opportunity.",
  },
  {
    icon: DoorOpen,
    title: "Exit Strategy",
    desc: "Discuss expected liquidity paths — IPO, secondary transfers, or buybacks — so you understand how and when capital may be unlocked.",
  },
  {
    icon: FileStack,
    title: "Documentation Support",
    desc: "Share purchase agreements, KYC, demat facilitation, and transaction paperwork handled with care and compliance awareness.",
  },
];

export default function UnlistedSharesPage() {
  return (
    <div className="unlisted-page">
      <PageHero
        badge="Unlisted Shares"
        title="Research-backed pre-IPO opportunities"
        subtitle="Access carefully screened unlisted equity with clear risk disclosure, documentation support, and exit awareness."
        actions={[
          { label: "Book Free Consultation", to: "/contact", primary: true },
          { label: "Talk to an Expert", to: "/contact" },
        ]}
      />

      <section className="pm-section unlisted-section">
        <div className="pm-container">
          <span className="pm-badge">
            <span className="pm-badge-dot" />
            End-to-End Support
          </span>
          <h2 className="pm-section-title">How we approach unlisted equity</h2>
          <p className="pm-section-sub">
            Opportunity screening with equal emphasis on benefits, risks, and
            exit clarity.
          </p>

          <div className="unlisted-grid">
            {SECTIONS.map((s) => {
              const Icon = s.icon;
              return (
                <article key={s.title} className="pm-card unlisted-card">
                  <div className="unlisted-card__icon">
                    <Icon size={22} />
                  </div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </article>
              );
            })}
          </div>

          <p className="unlisted-disclaimer">
            Unlisted shares involve higher risk and limited liquidity. Past
            performance of any company or sector is not indicative of future
            results. Please invest only after understanding the risks.
          </p>
        </div>
      </section>

      <CtaBand
        title="Interested in unlisted opportunities?"
        subtitle="Speak with our team to understand suitability, documentation, and current researched options."
        primary={{ label: "Book Free Consultation", to: "/contact" }}
        secondary={{ label: "Talk to an Expert", to: "/contact" }}
      />
    </div>
  );
}
